import { render, staticRenderFns } from "./ProductsCarousels.vue?vue&type=template&id=004d02c6&scoped=true"
import script from "./ProductsCarousels.vue?vue&type=script&lang=js"
export * from "./ProductsCarousels.vue?vue&type=script&lang=js"
import style0 from "./ProductsCarousels.vue?vue&type=style&index=0&id=004d02c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d02c6",
  null
  
)

export default component.exports